import styled from 'styled-components';

const SignUpContainer = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 10px rgba(59, 48, 48, 0.05);
  border-radius: 10px;
  padding: 16pt;
  max-width: 450px;
`;

const SignUpTitleSection = styled.h4`
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
`;

const SignUpLink = styled.a`
  font-weight: 400;
  font-size: 16px;
  color: #43a047;
  line-height: 24px;
`;

export { SignUpContainer, SignUpTitleSection, SignUpLink };
